import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import RenderWebshopArticle from './RenderWebshopArticle';

const RenderWebshopArticleView = () => {
  // Extract parameters from URL using useParams hook
  const [queryParameters] = useSearchParams()

  return (
    <RenderWebshopArticle 
      width={parseInt(queryParameters.get("width") ?? "0")} 
      height={parseInt(queryParameters.get("height") ?? "0")} 
      language={queryParameters.get("language") ?? "hu"} 
      id={queryParameters.get("id") ?? "OXPodcwbREOVvE787GxvLQ"} 
      datoplugin={false}
    />
  );
};

export default RenderWebshopArticleView;
